<template>
  <div class="source-wrap" v-loading="loading">
    <ul class="source-list" v-if="sources.length">
      <li class="source-list__item" v-for="(source, index) in sources" :key="index">
        <!--<div class="source-list__item-delete" @click="deleteSource(source.profile_id)">
          <i class="el-icon-close"></i>
        </div>-->
        <div class="pseudo-link-wrap" @click="goToLink(source)">
          <el-avatar :src="source.image" size="large"></el-avatar>
        </div>
        <div class="network-name">
          <img src="../../assets/img/vk-icon.svg" width="16px" v-if="source.network_name === 'vk'">
          <img src="../../assets/img/dz-icon.svg" width="16px" v-if="source.network_name === 'dz'">
          <img src="../../assets/img/ok-icon.svg" width="16px" v-if="source.network_name === 'ok'">
          <img src="../../assets/img/yt.png" width="16px" v-if="source.network_name === 'yt'">
          <img src="../../assets/img/twitter.svg" width="16px" v-if="source.network_name === 'tw'">
          <img src="../../assets/img/telegram.svg" width="16px" v-if="source.network_name === 'tg'">
          <img src="../../assets/img/facebook.svg" width="16px" v-if="source.network_name === 'fb'">
          <img src="../../assets/img/gs.svg" width="16px" v-if="source.network_name === 'gs'">
        </div>
        <div class="source-username">
          {{source.username.slice(0,14)}}
        </div>

      </li>
    </ul>
    <ul class="source-list" v-else>
      <template v-if="isLoaded">
        <li>
          Нет данных.
        </li>
      </template>
      <template v-else>
        <li class="source-list__item" v-for="item in limit" :key="item">
          <el-avatar  src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" size="large"></el-avatar>
        </li>
      </template>
    </ul>
    <el-divider></el-divider>
    <div class="subscribers__button-wrap" v-if="sources.length < count">
          <el-button @click="getSources">{{$t('feed.activeUsers.button')}}</el-button>
    </div>

  </div>
</template>

<script>
  /*
   component sources - list of sources
  */

  // api
  import { getSourcesApi, deleteSourcesApi } from "../../api/feeds";

  // components
  import notify from "../../helpers/notify";

  export default {
    name: 'Source',
    props: {
      active: {
        type: Boolean
      },
    },
    data() {
      return {
        isLoaded: false,
        loading: false,
        sources: [],
        offset: 0,
        start: 0,
        count: 0,
        limit: 95,
        drawer: false,
        direction: 'rtl',
      };
    },
    methods: {
      goToLink(source) {
        window.open(source.url, '_blank');
      },
      deleteSource(source_id) {
        let username = this.sources.find(item => item.profile_id === source_id).username;

        this.$alert(`Удалить источник ${username}?`, 'Удаление', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.handleDelete(source_id);
            } else {
              this.$message({
                type: 'info',
                message: `удаление отменено`
              });
            }
          }
        });
      },
      handleDelete(source_id) {
        let params = {
          source_id
        };

        this.loading = true;

        deleteSourcesApi(params).then(() => {
          this.loading = false;
          this.sources = this.sources.filter(item => item.profile_id !== source_id);
          notify.call(this, `Источник удален`, "success");
        });
      },
      getSources() {
        let params = {
          thread_id: this.$route.params.threadId,
          offset: this.offset,
          limit: this.limit,
          start: this.start,
          sources_only: true,
        };
        this.loading = true;
        getSourcesApi(params).then((resp) => {
          this.sources = [...this.sources, ...resp.data.members];
          this.offset = this.sources.length;
          this.count = resp.data.count
          this.start = this.sources.length;
          this.loading = false;
          this.isLoaded = true;
        });
      }
    },
    watch: {
      active(value) {
        if (value) {
          if (!this.sources.length) {
            this.getSources();
          }
        }
      }
    }
  };
</script>

<style>
  .source-list {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .source-list__item {
    position: relative;
    padding: 15px;
    margin-bottom: 20px;
  }
  .source-list__item-delete {
    right: 9px;
    top:9px;
    position: absolute;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 50%;
  }
  .network-name {
    position: absolute;
    bottom: 9px;
    left: 9px;
  }
  .pseudo-link-wrap {
    cursor: pointer;
  }
  .source-username {
    position: absolute;
    left: 5px;
    padding-top: 5px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    text-align: center;
    width: 60px;
  }
</style>
